export const makeContactInfo = (contactInfo: string): string => {
    // eslint-disable-next-line no-useless-escape
    const EMAIL_PATTERN = /.+\@.+\..+/;
    if (!EMAIL_PATTERN.test(contactInfo)) {
        return makeLink(contactInfo);
    }
    return contactInfo;
};

export const makeLink = (url: string): string => {
    // eslint-disable-next-line no-useless-escape
    const URL_WITH_PROTOCOL = /^(((?:f|ht)tps)|tel|malto)?\:\/\//;
    if (!URL_WITH_PROTOCOL.test(url)) {
        return `https://${url}`;
    }
    return url;
};
